import { useState } from 'react'

import { WidgetHeader } from '../../Widget'
import { Component, ComponentProps } from '../Component'
import { controls, text } from '../Controls'

import { WidgetProviderProps } from './WidgetProviderProps'

export function WidgetHeaderUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(text('title', 'Widget title'))
  )

  return (
    <WidgetProviderProps>
      <Component
        {...props.getValues()}
        Component={WidgetHeader}
        name='WidgetHeader'
      />
      <ComponentProps name='WidgetHeader' value={props} onChange={setProps} />
    </WidgetProviderProps>
  )
}
